/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { FilterWithDropdownList } from '../../components/packages/FilterWithDropdownList';
import { SelectRealtorFiltersLayout } from '../../components/SelectRealtorFiltersLayout';
import { useFiltersForm } from './utils/useFiltersForm';
import { Provider } from '../../context/widgetContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectRealtorFiltersWidget = function SelectRealtorFiltersWidget(props) {
  var onChange = props.onChange,
      initialState = props.initialState,
      stateRef = props.stateRef,
      targetPage = props.targetPage;
  var isDesktop = useIsDesktop();

  var _useFiltersForm = useFiltersForm({
    onChange: onChange,
    initialState: initialState,
    stateRef: stateRef
  }),
      state = _useFiltersForm.state,
      setDealType = _useFiltersForm.setDealType,
      setOfferType = _useFiltersForm.setOfferType,
      setObjectType = _useFiltersForm.setObjectType,
      objectTypeOptions = _useFiltersForm.objectTypeOptions,
      dealTypeSelectorOptions = _useFiltersForm.dealTypeSelectorOptions,
      offerTypeSelectorOptions = _useFiltersForm.offerTypeSelectorOptions;

  return /*#__PURE__*/_jsx(Provider, {
    value: {
      targetPage: targetPage,
      isDesktop: isDesktop
    },
    children: /*#__PURE__*/_jsx(SelectRealtorFiltersLayout, {
      dealTypeFilter: /*#__PURE__*/_jsx(FilterWithDropdownList, {
        values: dealTypeSelectorOptions,
        value: state.dealType,
        onValueChange: setDealType,
        placeholder: "\u0422\u0438\u043F \u0441\u0434\u0435\u043B\u043A\u0438",
        testId: "dealType_filter",
        isFirstFilter: true
      }),
      offerTypeFilter: /*#__PURE__*/_jsx(FilterWithDropdownList, {
        values: offerTypeSelectorOptions,
        value: state.offerType,
        onValueChange: setOfferType,
        placeholder: "\u0422\u0438\u043F \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438",
        testId: "offerType_filter"
      }),
      objectTypeFilter: /*#__PURE__*/_jsx(FilterWithDropdownList, {
        values: objectTypeOptions,
        value: state.objectType,
        onValueChange: setObjectType,
        placeholder: "\u041E\u0431\u044A\u0435\u043A\u0442",
        testId: "objectType_filter",
        isLastFilter: true
      })
    })
  });
};
SelectRealtorFiltersWidget.displayName = 'SelectRealtorFiltersWidget';